import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {
    MyMemorableDays,
} from "../../redux/selfService/selfServiceSlice";
import React, {useState} from "react";
import LoadingSpinner from "../../components/LoadingSpinner";
import PageName from "../../components/PageName";
import SuccessModal from "../../components/SuccessModal";
import Card from "../../components/Base/Card";
import ErrorViewer from "../../components/ErrorViewer";
import Required from "../../components/Required";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import BaseDatePicker from "../../components/Base/BaseDatePicker";

const MyMemorableDaysPage = ()=>{
    const dispatch = useAppDispatch();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const { isLoading } = useAppSelector((state) => state?.selfService);


    const validationSchema = Yup.object().shape({
        title: Yup.string().required("Please enter a title"),
        eventName: Yup.string().required("Please enter an event name"),
        eventDate: Yup.string().required("Enter the date of the event"),
    });

    const defaultValues = {
        title: "",
        eventName: "",
        eventDate: ""
    }

    const { handleSubmit, register, setValue, reset, formState: { errors },} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues
    });

    const onSubmit = (values: any) => {
        const formattedValues = {
            ...values,
            eventDate: new Date(values.eventDate).toISOString(),
        }
        dispatch(MyMemorableDays(formattedValues)).then(res=>{
            if(res?.type === 'selfService/MyMemorableDays/fulfilled'){
                setSuccessMessage(res.payload.statusMessage)
                reset(defaultValues)
                setShowSuccessModal(true)
            }
        })
    }
    return (
        <div className="statement-page">
            <PageName pageName={"My Memorable Days (Let's  Celebratee you)"}/>
            <div>
                <SuccessModal
                    showModal={showSuccessModal}
                    onClose={()=>setShowSuccessModal(false)}
                    note={successMessage}
                />
                <div className="mx-4">


                    <div className="h1 text-grayscaleBody">
                        My Memorable Days
                    </div>
                    <div className="w-full">
                        <Card className="mb-8 bg-grayscaleBG">
                            <div className="section-card">
                                <div className="pt-12 whitespace-pre mr-6">
                                    My Memorable Days
                                </div>
                                <div className="w-full">
                                    <div className="mx-auto max-w-[400px]">
                                        <div className="form__group">
                                            <label htmlFor="title" className="form__label">
                                                Event Title <Required />
                                            </label>
                                            <input placeholder="Event Title" type="text" id="title"
                                                   className="form__input" {...register("title")} />
                                            {errors.title && (
                                                <ErrorViewer message={errors.title.message as string}/>
                                            )}
                                        </div>
                                        <div className="form__group">
                                            <label htmlFor="eventName" className="form__label">
                                                Event Name <Required />
                                            </label>
                                            <input placeholder="Event Name" type="text" id="eventName"
                                                   className="form__input" {...register("eventName")} />
                                            {errors.eventName && (
                                                <ErrorViewer message={errors.eventName.message as string}/>
                                            )}
                                        </div>
                                        <div className="form__group">
                                            <label htmlFor="eventDate" className="form__label">
                                                Event Date <Required />
                                            </label>
                                            <BaseDatePicker
                                                onChange={(date: Date) => {
                                                    // @ts-ignore
                                                    setValue("eventDate", date);
                                                }}
                                            />
                                            {errors.eventDate && (
                                                <ErrorViewer message={errors.eventDate.message as string}/>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                        <div className="flex justify-end text-primary mb-40">
                            <button
                                className="btn btn-primary font-semibold mr-4"
                                onClick={handleSubmit(onSubmit)}
                                disabled={isLoading}
                            >
                                {
                                    isLoading ? <LoadingSpinner /> : "Add"
                                }
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
export default MyMemorableDaysPage;